import { render } from "./ContainerTable.vue?vue&type=template&id=1bf45031&scoped=true&ts=true"
import script from "./ContainerTable.vue?vue&type=script&lang=ts"
export * from "./ContainerTable.vue?vue&type=script&lang=ts"

import "./ContainerTable.vue?vue&type=style&index=0&id=1bf45031&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf45031"]])

export default __exports__